import styled from 'styled-components'

export const OtherLocations = styled.div`
  padding-bottom: 40px;

  h4 {
    margin-bottom: 12px;
  }
`
